import { api } from "../App";
import { SET_LOG_SETTING_TABLES, SET_LOG_SETTING, SET_LOG_SETTING_TABLES_COLUMNS, SET_LOG_SETTING_TABLES_LOADING } from "./types";



export const getLogSetting = () => async (dispatch, getState) => {
    try {
        const { data } = await api.get('/log_settings')
        dispatch({ type: SET_LOG_SETTING, payload: data });
    } catch (ERR) {
        console.log(ERR)
    } finally {
    }
};

export const getLogSettingTables = (yearId, params) => async (dispatch, getState) => {
    try {
        dispatch({ type: SET_LOG_SETTING_TABLES_LOADING, payload: true });
        const { data } = await api.get(`/log_settings/tables`)
        dispatch({ type: SET_LOG_SETTING_TABLES, payload: data });
    } catch (ERR) {
        console.log(ERR)
    } finally {
        dispatch({ type: SET_LOG_SETTING_TABLES_LOADING, payload: true });

    }
};

// КОЛОНКИ ТАБЛИЦЫ
export const getLogSettingTablesColumns = (nameTable) => async (dispatch, getState) => {
    try {
        dispatch({ type: SET_LOG_SETTING_TABLES_LOADING, payload: true });
        const { data } = await api.get(`/log_settings/tables/${nameTable}/columns`)
        dispatch({ type: SET_LOG_SETTING_TABLES_COLUMNS, payload: data });
    } catch (ERR) {
        console.log(ERR)
    } finally {
        dispatch({ type: SET_LOG_SETTING_TABLES_LOADING, payload: true });
    }
};

export const createLogSettingTable = (data) => async (dispatch, getState) => {
    let success
    try {
        dispatch({ type: SET_LOG_SETTING_TABLES_LOADING, payload: true });
        await api.post('/log_settings', data);
        await dispatch(getLogSetting())
        success = true
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_LOG_SETTING_TABLES_LOADING, payload: false });
        return success
    }
}

export const updateLogSettingTable = ({ idlogset, ...data }) => async (dispatch, getState) => {
    let success
    try {
        dispatch({ type: SET_LOG_SETTING_TABLES_LOADING, payload: true });
        await api.put(`/log_settings/${idlogset}`, data);
        await dispatch(getLogSetting())
        success = true
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_LOG_SETTING_TABLES_LOADING, payload: false });
        return success
    }
}

export const deleteLogSettingTable = (idlogset) => async (dispatch, getState) => {
    try {
        dispatch({ type: SET_LOG_SETTING_TABLES_LOADING, payload: true });
        await api.delete(`/log_settings/${idlogset}`);
        await dispatch(getLogSetting())
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_LOG_SETTING_TABLES_LOADING, payload: false });
    }
}